<template>
    <section>
        <!-- 検索窓 -->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" v-loading="toolbarLoading">
            <el-form :inline="true">
                <el-form-item>
                    <el-button type="primary" v-on:click="exportCsv" v-if="adminRole">CSV出力</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd">新規追加</el-button>
                </el-form-item>
                <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="30"
                           :total="total" style="float:right;">
                </el-pagination>
            </el-form>
        </el-col>
        <!-- /検索窓 -->

        <!-- リスト -->
        <el-table :data="images" highlight-current-row v-loading="listLoading" @selection-change="selsChange"
                  style="width: 100%;">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="name" label="名前" width="200">
            </el-table-column>
            <el-table-column label="プレビュー" width="300">
                <template scope="scope">
                    <img class="trim" width="100" height="100" @click="openModal(scope.row)"
                         :src="`${getbucket}/images/${scope.row.path}`">
                </template>
            </el-table-column>
            <el-table-column label="更新日時" width="210" sortable>
                <template scope="scope">
                    {{ scope.row.updatedAt | formatDate }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template scope="scope">
                    <el-button v-if="role !== 'general'" size="small" @click="handleEdit(scope.$index, scope.row)">編集</el-button>
                    <el-button v-if="role !== 'general'" type="danger" size="small" @click="handleDel(scope.$index, scope.row)">削除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- /リスト -->

        <!-- 一括削除 -->
        <el-col :span="24" class="toolbar" v-if="role !== 'general'">
            <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">一括削除</el-button>
        </el-col>
        <!-- /一括削除 -->

        <!-- 画像モーダル -->
        <el-dialog title="イメージ" v-model="imageVisible" size="full">
            <el-form>
                <img class="trim" width="500" height="500"
                     :src="modalImage">
            </el-form>
        </el-dialog>
        <!-- /画像モーダル -->

        <!-- 新規追加 -->
        <el-dialog title="新規追加" v-model="addFormVisible" :close-on-click-modal="false" @close="closeAddForm">
            <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
                <el-form-item label="画像名" prop="name">
                    <el-input v-model="addForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="画像" prop="path">
                    <el-upload drag
                               action=""
                               :multiple="false"
                               accept="image/*"
                               ref="upload"
                               :auto-upload="false"
                               :disabled="uploadDisable"
                               :on-change="onChange">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="closeAddForm">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">登録</el-button>
            </div>
        </el-dialog>
        <!-- /新規追加 -->

        <!-- 編集 -->
        <el-dialog title="編集" v-model="editFormVisible" :close-on-click-modal="false" @close="closeEditForm">
            <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
                <el-form-item label="画像名" prop="name">
                    <el-input v-model="editForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="画像" prop="path">
                    <el-input v-model="editForm.path" disabled></el-input>
                </el-form-item>
                <el-form-item label="作成日時">
                    <el-date-picker type="datetime"
                                    placeholder="作成日時"
                                    format="yyyy/MM/dd HH:mm"
                                    v-model="editForm.createdAt"
                                    disabled>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="更新日時">
                    <el-date-picker type="datetime"
                                    placeholder="更新日時"
                                    format="yyyy/MM/dd HH:mm"
                                    v-model="editForm.updatedAt"
                                    disabled>
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="closeEditForm">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">登録</el-button>
            </div>
        </el-dialog>
        <!-- /編集 -->

    </section>
</template>

<script>
    import util from '../../common/js/util'
    import * as ImageRequest from '../../api/image';
    import ElOption from "../../../node_modules/element-ui/packages/select/src/option.vue";
    import ElUpload from "../../../node_modules/element-ui/packages/upload/src/index.vue";
    import config from "../../config/app";
    import { formatDate } from "../../components/filters/format";
    import moment from "moment";
    import * as User from '../../api/cognitoUser';

    export default {
        components: {
            ElUpload,
            ElOption,
        },
        filters: {
            formatDate,
        },
        data() {
            return {
                getbucket: config.aws.s3.getbucket,

                // イメージ系
                imageVisible: false,
                modalImage: "",
                uploadDisable: false,

                images: [],
                total: 0,
                page: 1,
                listLoading: false,
                sels: [],
                attributes: JSON.parse(sessionStorage.getItem('attributes')),
                role: JSON.parse(sessionStorage.getItem('attributes'))['custom:role'],
                user: JSON.parse(sessionStorage.getItem('user')),
                adminRole: User.checkAdminRoleBySession(),
                toolbarLoading: false,

                // 新規系
                addFormVisible: false,
                addLoading: false,
                addFormRules: {
                    name: [
                        { required: true, message: '画像名を入力してください', trigger: 'blur' }
                    ],
                    path: [
                        { required: true, validator: this.validatePath, trigger: "blur" }
                    ]
                },
                addForm: {
                    name: "",
                    path: "",
                    sub: "",
                    username: "",
                },

                // 編集
                editFormVisible: false,
                editLoading: false,
                editFormRules: {
                    name: [
                        { required: true, message: '画像名を入力してください', trigger: 'blur' }
                    ],
                },
                editForm: {
                    name: "",
                    path: "",
                    sub: "",
                    username: "",
                }
            }
        },
        methods: {
            validatePath(rule, value, callback) {
                console.log(this.$refs.upload.uploadFiles);
                if (this.$refs.upload.uploadFiles.length === 0) {
                    callback(new Error("ファイルを選択してください。"));
                } else {
                    callback();
                }
            },
            onChange() {
                this.uploadDisable = this.$refs.upload.uploadFiles.length > 0;
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getImages();
            },
            getImages() {
                this.listLoading = true;
                const params = {
                    params: {
                        count: config.pageCount,
                        order: "updatedAt",
                        sort: "DESC",
                        offset: (this.page - 1) * config.pageCount,
                        fields: this.getSearchQueryFields(this.role),
                        q: this.attributes['sub'],
                    }
                };
                ImageRequest.count(params)
                    .then(res => {
                        this.total = res.data.count;
                    });
                ImageRequest
                    .search(params)
                    .then(res => {
                        this.images = res.data;
                        this.listLoading = false;
                    });
            },
            handleDel(index, row) {
                this.$confirm('削除してもよろしいですか？', '確認', {
                    type: 'warning'
                })
                .then(() => {
                    this.listLoading = true;
                    return ImageRequest.remove(row.id, row.path)
                    .then(() => {
                        this.$message({
                            message: '削除しました',
                            type: 'success'
                        });
                    })
                    .catch(err => {
                        this.$message({
                            message: 'コンテンツに紐付いた画像が含まれています。コンテンツを削除してから再度お試し下さい。',
                            type: 'warning'
                        });
                    });
                })
                .then(() => {
                    this.getImages();
                    this.listLoading = false;
                })
                .catch(err => {/*キャンセル*/});

            },
            handleAdd() {
                this.addFormVisible = true;
                this.addForm = {
                    name: '',
                    path: '',
                    sub: this.attributes['sub'],
                    username: this.user['username'],
                };
            },
            closeAddForm() {
                this.$refs.upload.clearFiles();
                this.$refs.addForm.resetFields();
                this.addFormVisible = false;
                this.onChange();
            },
            closeEditForm() {
                this.$refs.editForm.resetFields();
                this.editFormVisible = false;
            },
            openModal(row) {
                this.imageVisible = true;
                this.modalImage = `${this.getbucket}/images/${row.path}`
            },
            addSubmit() {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('登録してもよろしいですか？', '確認', {})
                            .then(() => {
                                this.addLoading = true;
                                const params = Object.assign({}, this.addForm);
                                const file = this.$refs.upload.uploadFiles[0];
                                params.body = file.raw;
                                params.path = file.name;

                                return ImageRequest.add(params)
                                    .then(res => {
                                        this.addLoading = false;
                                        this.$message({
                                            message: '登録しました',
                                            type: 'success'
                                        });
                                        this.closeAddForm();
                                        this.getImages();
                                    });
                            });
                    }
                });
            },
            handleEdit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
                this.editForm.sub = this.attributes['sub'];
                this.editForm.username = this.user['username'];
            },
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('登録してもよろしいですか？', '確認', {}).then(() => {
                            this.editLoading = true;
                            const params = Object.assign({}, this.editForm);
                            ImageRequest.edit(this.editForm.id, params).then(res => {
                                this.editLoading = false;
                                this.$message({
                                    message: '登録しました',
                                    type: 'success'
                                });
                                this.closeEditForm();
                                this.getImages();
                            });
                        });
                    }
                });
            },
            selsChange(sels) {
                this.sels = sels;
            },
            batchRemove() {
                const selectedItemInfo = this.sels.map(item => {
                    return {
                        id: item.id,
                        path: item.path,
                    }
                });
                this.$confirm('選択した項目を削除してもよろしいですか？', '確認', {
                    type: 'warning'
                })
                .then(() => {
                    this.listLoading = true;
                    return ImageRequest.batchRemove(selectedItemInfo)
                    .then(() => {
                        this.$message({
                            message: '削除しました',
                            type: 'success'
                        });
                    })
                    .catch(err => {
                        this.$message({
                            message: 'コンテンツに紐付いた画像が含まれています。コンテンツを削除してから再度お試し下さい。',
                            type: 'warning'
                        });
                    });
                })
                .then(() => {
                    this.getImages();
                    this.listLoading = false;
                })
                .catch(err => {/*キャンセル*/});
            },
            getSearchQueryFields(role) {
              if(role === 'general'){
                return  "createdBy";
              }else {
                return  null;
              }
            },
            exportCsv: async function() {
                this.listLoading = true;
                this.toolbarLoading = true;
                // ヘッダ行
                const columns = [
                    '名前',
                    '更新日時',
                ];
                const header = columns.join(',') + '\n';

                // データ取得（全件）
                const params = {
                    params: {
                        order: 'updatedAt',
                        sort: 'DESC',
                        count: this.total,
                    }
                };
                const image = await ImageRequest
                        .search(params)
                        .then(res => {
                            return res.data;
                        });

                let arrImage = [];
                for (var i = 0; i < image.length; i++) {
                    const data = [
                        image[i].name,
                        formatDate(image[i].updatedAt),
                    ];
                    arrImage.push(data);
                }
                const body = arrImage.join('\n');

                // CSVダウンロード
                const iconv = require("iconv-lite");
                const data = iconv.encode(header + body, 'windows-31j');
                const blob = new Blob([ data ], { "type" : "text/csv" });
                const url = window.URL.createObjectURL(blob);

                let link = document.createElement('a');
                link.download = 'swipe_image_' + moment().format("YYYYMMDD") + '.csv';
                link.href = url;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.listLoading = false;
                this.toolbarLoading = false;
            }
        },
        mounted() {
            this.getImages();
        }
    }

</script>

<style scoped>
    .trim {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
    }
</style>


// WEBPACK FOOTER //
// Image.vue?3dad847c